import React from 'react';
import CustomDropdown from './CustomDropdown';
import { getPriorityTextClass } from '../../utils/priorityColors';

// Badge styling helper
const getBadgeClass = (type, value) => {
  if (type === 'priority') {
    return getPriorityTextClass(value);
  }
  return 'text-gray-300';
};

const BadgeDropdown = ({
  value,
  onChange,
  options,
  type, // 'priority', 'domain', or 'status'
  placeholder = "Select...",
  className = "",
  disabled = false,
  showAllOption = false
}) => {
  // Helper function to get correct plural form
  const getPlural = (type) => {
    switch (type) {
      case 'status': return 'statuses';
      case 'priority': return 'priorities';
      case 'domain': return 'domains';
      default: return `${type}s`;
    }
  };

  // Add "All" option if requested
  const allOptions = showAllOption
    ? [{ value: 'all', label: `All ${getPlural(type)}` }, ...options]
    : options;

  const renderBadge = (option) => {
    if (option.value === 'all') {
      return <span className="text-gray-300">{option.label}</span>;
    }

    const badgeClass = getBadgeClass(type, option.value);
    const priorityOnlyTextStyle = type === 'priority' ? '' : '';
    return (
      <span className={`${priorityOnlyTextStyle} text-xs font-medium ${badgeClass}`}>
        {option.label}
      </span>
    );
  };

  return (
    <CustomDropdown
      value={value}
      onChange={onChange}
      options={allOptions}
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      renderOption={renderBadge}
      renderSelected={renderBadge}
    />
  );
};

export default BadgeDropdown;